import(/* webpackMode: "eager" */ "/app/src/app/shop/[shopId]/layout.tsx");
